import React, { Component } from 'react';
import './ReviewApplicants.css';

import { AccentColor } from 'helpers/AccentColorHelper';
import { formatPhone } from 'helpers/Formatter';

class EmergencyContact extends Component {
  render() {
    const tenantEmergencyContacts = this.props.emergencyContactDetails;

    const style = {
      row: {
        padding: '0 15px',
        marginTop: '30px',
      },
      header: {
        color: '#4e4e4e',
        fontSize: '18px',
        marginBottom: '0',
        marginTop: '0',
      },
      sub_header: {
        marginTop: '5px',
        marginBottom: 0,
        color: '#6F6F6F',
        textAlign: 'justify',
        overflowWrap: 'break-word',
      },
      button_container: {
        padding: '30px 15px 10px 15px',
        marginTop: '-10px',
        textAlign: 'center',
      },
      button: {
        backgroundColor: AccentColor(),
        color: '#fff',
      },
      padding_left: {
        padding: '15px 0px 0 0',
        textAlign: 'left',
      },
      titleContentStyle: {
        borderBottom: '0px solid #e0e0e0',
        padding: '20px 20px 5px 20px',
        textAlign: 'center',
        color: '#4e4e4e',
      },
      customContentStyle: {
        maxWidth: '400px',
        width: '95%',
      },
      bodyContentStyle: {
        padding: '10px 20px 20px 20px',
        textAlign: 'center',
      },
      deletebodyContentStyle: {
        padding: '20px 5px 0px 5px',
        textAlign: 'center',
      },
      subMenuHeader: {
        backgroundColor: '#f7f7f7',
        margin: '20px -15px',
        textAlign: 'center',
        color: '#888888',
      },
    };

    let emergency_contacts;
    if (tenantEmergencyContacts && tenantEmergencyContacts.length !== 0) {
      emergency_contacts = tenantEmergencyContacts.map((emergencyContact, index) => (
        <div key={index} className="row" style={style.row}>
          <div className="wrapper">
            <h5 style={style.header}>{emergencyContact.full_name}</h5>
            <h5 style={style.sub_header}>{emergencyContact.email}</h5>
            <h5 style={style.sub_header}>{formatPhone(emergencyContact.phone_number)}</h5>
            <h5 style={style.sub_header}>{emergencyContact.relationship}</h5>
          </div>
        </div>
      ));
    } else {
      emergency_contacts = (
        <div className="small-message">
          <small>No Emergency Contact Details Provided.</small>
        </div>
      );
    }

    return (
      <div>
        <div className="row" style={style.subMenuHeader}>
          <h5> Emergency Contact Information </h5>
        </div>

        {emergency_contacts}
      </div>
    );
  }
}

export default EmergencyContact;
